/* eslint-disable no-unused-vars */
/* eslint-disable indent */

import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Progress,
  Radio,
  Spin,
  Tooltip,
  message,
  Input,
  Select,
  Empty,
} from "antd";
import { useParams } from "react-router-dom";
import { camelCase } from "../../../utils";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import editButton from "../../../assests/images/penEdit.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

// import rightArrow from "../../../assests/images/rightVector.svg";
import shipmentTruck from "../../../assests/images/shipmentTruck.svg";
import TruckProgress from "../../../assests/images/TruckProgress.svg";
import urls from "../../../api/urls";
import API from "../../../api";

import lock from "../../../assests/images/lock.svg";
import readytolockicon from "../../../assests/images/readytolockicon.svg";
import tik from "../../../assests/images/tik.svg";
import Minicard from "./Minicard";
import Bigcard from "./Bigcard";
import "./style.scss";
import Heading from "../../../components/Heading";
import useCustomNavigate from "../../../components/customNavigationHook";
const {
  GET_DRIVER_LIST_NEW,
  PUT_DRIVER_DETAILS,
  GET_VEHICLES_TO_LOAD,
  GET_MANIFESTED_SHIPMENTS,
  LOAD_TO_VEHICLE,
  CP_EWAY_BILL_TABLE,
} = urls;
const { Option } = Select;

// Sub-components
const Header = ({ shipmentCount, totalWeight, totalVolWeight }) => (
  <>
    <div className="space-between top-heading">
      <div>
        <Heading title={"Load to vehicle"} navigateTo={"/viewBooking"} />
      </div>
      <div className="header-item-two">
        <b>Shipments: </b>
        <div className="num">{shipmentCount}</div>
      </div>
    </div>

    <Row className="middle-heading">
      <div className="head">
        <h4>
          <img src={shipmentTruck} alt="shipment truck" /> Booked Shipment (s)
        </h4>
        <p className="total-weight">
          Total Vol Weight: <span>{totalVolWeight || 0} Kg</span>
        </p>
        <p className="total-weight">
          Total Weight: <span>{totalWeight || 0} Kg</span>
        </p>
      </div>
    </Row>
  </>
);

const TruckHeader = ({ loadTruckDriver, loaded, onDriverLoadChange }) => (
  <Row className="header-two space-between">
    <div>
      <h4>Vehicles</h4>
    </div>
    <div>
      <Radio.Group
        onChange={onDriverLoadChange}
        value={loadTruckDriver}
        className="d-flex"
        disabled={loaded}
      >
        <Radio value="List">List</Radio>
        <Radio value="Custom">Custom</Radio>
      </Radio.Group>
    </div>
  </Row>
);

const CustomTruckForm = ({ form, loaded, filterManifestShips, onSubmit }) => (
  <Row className="global-form-row">
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
      autoComplete="off"
      className="global-form p-2"
    >
      <Row className="global-form-row">
        <Col span={11}>
          <Form.Item
            name="driverName"
            label="Driver name"
            rules={[{ required: true, message: "Enter driver name" }]}
          >
            <Input
              maxLength={20}
              placeholder="Enter driver name"
              disabled={loaded || filterManifestShips?.length === 0}
            />
          </Form.Item>
        </Col>
        <Col span={2} />
        <Col span={11}>
          <Form.Item
            name="vehicleNumber"
            label="Vehicle Number"
            rules={[{ required: true, message: "Enter vehicle number" }]}
          >
            <Input
              maxLength={20}
              disabled={loaded || filterManifestShips?.length === 0}
              placeholder="Enter vehicle number"
            />
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item name="contactNumber" label="Contact number">
            <Input
              maxLength={10}
              disabled={loaded || filterManifestShips?.length === 0}
              placeholder="Enter contact number"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </Row>
);

const TruckList = ({
  trucks,
  radioValue,
  hubName,
  onRadioChange,
  state,
  driverNameList,
  form,
  setState,
  setLoading = () => {},
}) => {
  const updateDriver = async (e) => {
    const vehicleNumber = state?.selectedTruck[0]?.vehicleNo;
    let choosenDriver = driverNameList?.find((data) => data?.driverId == e);
    setLoading(true);
    try {
      const response = await API.Api(
        `${PUT_DRIVER_DETAILS}${vehicleNumber}/driver/${choosenDriver?.driverId}`
      ).put();

      if (response?.status) {
        setLoading(false);
        form.setFieldValue("contactNumber", choosenDriver?.contactNumber || "");
        if (choosenDriver) {
          setState((prev) => ({
            ...prev,
            selectedDriver: choosenDriver,
          }));
        }
      } else {
        setLoading(false);
        setState((prev) => ({
          ...prev,
          selectedDriver: null,
        }));
        form.setFieldValue("drivername", null);

        message.error(response?.response?.data?.message || "Network error");
      }
    } catch (error) {
      setLoading(false);
      form.setFieldValue("drivername", null);
      setState((prev) => ({
        ...prev,
        selectedDriver: null,
      }));
      message.error("Failed to update driver");
    }
  };

  return (
    <>
      <div className="truck-list-container">
        {trucks?.length > 0 ? (
          trucks?.map((item, index) => (
            <Row
              key={item?.vehicleNo}
              className={`truck-item ${
                radioValue == index ? "green" : "pointer"
              }`}
              onClick={(e) => {
                e.preventDefault();
                if (radioValue !== index) {
                  onRadioChange(index);
                }
              }}
            >
              <Col span={24} className="middle-heading-right">
                <div className="truck-one-first-heading">
                  <p>{hubName}</p>
                </div>
                <Row>
                  <Form layout="vertical" form={form}>
                    <div className="d-flex">
                      <div style={{ width: "65%" }}>
                        {radioValue == index && driverNameList?.length ? (
                          <div className="d-flex">
                            <div style={{ width: "50%" }}>
                              <Form.Item
                                label="Driver name"
                                name="drivername"
                                colon={false}
                                className="input-edit"
                                rules={[
                                  {
                                    required: true,
                                    message: "Enter driver name",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Please Select Name"
                                  onSelect={updateDriver}
                                  // defaultValue={state?.selectedTruck[0]?.driverId}
                                >
                                  {driverNameList?.length > 0
                                    ? driverNameList?.map((driver) => (
                                        <Option
                                          key={driver?.driverId}
                                          // value={driver?.driverId}
                                        >
                                          {driver?.name}
                                        </Option>
                                      ))
                                    : null}
                                </Select>
                              </Form.Item>
                            </div>

                            <div style={{ width: "40%" }}>
                              <Form.Item
                                label="Contact number"
                                name="contactNumber"
                                className="input-edit"
                                colon={false}
                              >
                                <Input disabled type="text" maxLength={10} />
                              </Form.Item>
                            </div>
                          </div>
                        ) : null}

                        <div className="d-flex">
                          <div style={{ width: "50%" }}>
                            <Form.Item label="Truck" colon={false}>
                              {item?.vehicleNo}
                            </Form.Item>
                          </div>
                          <div style={{ width: "30%" }}>
                            <Form.Item label="Load capacity" colon={false}>
                              {(item?.loadCapacity / 1000)?.toFixed(2)} Ton
                            </Form.Item>
                          </div>
                        </div>
                        <Form.Item label="Route permit type" colon={false}>
                          {item?.permitType}
                        </Form.Item>
                      </div>
                      <div style={{ width: "35%" }}>
                        <Col>
                          <Row className="truck-img">
                            <img
                              src={TruckProgress}
                              style={{ width: "100%" }}
                            />
                            {radioValue == index ? (
                              <Progress
                                // style={{ width: "100%" }}
                                percent={(
                                  (parseInt(
                                    state?.manifestData?.totalweight || 0
                                  ) / state.selectedTruck[0]?.loadCapacity ||
                                    0) * 100
                                ).toFixed(0)}
                              />
                            ) : (
                              <Progress percent={0} />
                            )}
                          </Row>
                        </Col>
                      </div>
                    </div>
                  </Form>
                </Row>
              </Col>
            </Row>
          ))
        ) : (
          <Empty
            description="No vehicles found"
            style={{ textAlign: "center", marginTop: "10%" }}
          />
        )}
      </div>
    </>
  );
};

const Footer = ({
  filterByweightTruck,
  loadToVehicle,
  hide,
  ltv,
  loadTruckDriver,
  filterManifestShips,
  customForm,
  onUpdateEway,
  onLoadVehicle,
  checkEwayBills,
  state,
  setState = () => {},
}) => {
  if (!filterByweightTruck) return null;

  return (
    <Row className="footer-button">
      <Col>
        {loadTruckDriver === "Custom" ? (
          <div className="d-flex">
            <Button
              className={`load-to-vehicle ${hide}`}
              disabled={filterManifestShips?.length == 0}
              onClick={() => customForm.submit()}
            >
              {checkEwayBills ? " Load to vehicle" : "Load and Lock manifest"}
            </Button>
          </div>
        ) : (
          <div className="d-flex" style={{ alignItems: "center" }}>
            <Button
              className={`cancel-btn ${hide} mr-1`}
              onClick={() =>
                setState((prev) => ({ ...prev, radioValue: null }))
              }
            >
              CANCEL
            </Button>
            <Button
              className={`load-to-vehicle ${hide}`}
              disabled={
                state?.radioValue == null || state?.driverNameList?.length == 0
              }
              onClick={onLoadVehicle}
            >
              {checkEwayBills ? " Load to vehicle" : "Load and Lock manifest"}
            </Button>
          </div>
        )}
      </Col>
    </Row>
  );
};

// Constants
const INITIAL_STATE = {
  manifestListArr: [],
  manifestData: [],
  vehicleResultData: [],
  driverNameList: [],
  selectedTruck: [],
  loadTruckDriver: "List",
  loading: false,
  radioValue: null,
  filteredTruck: null,
};

const ManifestComponent = () => {
  const navigate = useCustomNavigate();
  const [form] = Form.useForm();
  const [customForm] = Form.useForm();

  const [state, setState] = useState(INITIAL_STATE);

  const {
    manifestListArr,
    manifestData,
    vehicleResultData,
    driverNameList,
    selectedTruck,
    loadTruckDriver,
    // loading,
    radioValue,
    loaded,
    loadToVehicle,
    editBtnStatus,
  } = state;

  const manifestedId = useParams();

  // const hubName = camelCase(
  //   JSON.parse(localStorage.getItem("userId"))?.premises?.parentPremiseName
  // );

  // Computed properties
  const filterByweightTruck = vehicleResultData?.filter(
    ({ status, loadCapacity }) =>
      status === "ACTIVE" && loadCapacity >= manifestData?.totalweight
  );

  let filterManifestShips = manifestListArr?.filter(function (el) {
    return el != null && el?.bookingStatus?.toUpperCase() === "MANIFESTED";
  });

  // API Calls
  const getDriverList = async (filterTruckData) => {
    if (!filterTruckData?.length) return;

    setLoading(true);

    try {
      const response = await API.Api(
        `${GET_DRIVER_LIST_NEW}`
      ).getWithPremiseHeader();

      if (response?.status) {
        setLoading(false);
        setState((prev) => ({
          ...prev,
          driverNameList: response?.response?.data,
        }));
      } else {
        setLoading(false);
        message.error(response?.response?.data?.message);
        setState((prev) => ({
          ...prev,
          driverNameList: [],
        }));
      }
    } catch (error) {
      message.error("Failed to fetch driver list");
      setLoading(false);
    }
  };

  // Event Handlers
  const onRadioChange = (value) => {
    form.resetFields();
    setState((prev) => ({
      ...prev,
      radioValue: value,

      selectedDriver: null,
    }));
  };

  const onDriverLoadChange = (e) => {
    setState((prev) => ({ ...prev, loadTruckDriver: e.target.value }));
  };

  const [loading, setLoading] = useState(false);
  const [checkEwayBills, setCheckEwayBills] = useState(false);

  useEffect(() => {
    if (
      manifestListArr &&
      manifestListArr?.some((val) => val?.ewayBillNumber)
    ) {
      setCheckEwayBills(true);
    } else {
      setCheckEwayBills(false);
    }
  }, [manifestListArr]);

  // console.log(checkEwayBills, "checkEwayBills");

  const handleStatus = async () => {
    setLoading(true);
    let lockManifestPayload = {
      status: "LOCKED",
    };

    let response = await API.Api(
      CP_EWAY_BILL_TABLE + `${manifestedId?.id}`
    ).putIdHeader(lockManifestPayload);
    if (response?.status) {
      setLoading(false);
      message.success(
        response?.response?.data?.message ||
          "Loaded to vehicle and manifest locked successfully"
      );
      navigate("/viewBooking");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  // Custom Vehicle Loading
  const customLoadToVehicleSubmit = async (payload) => {
    let manifestDriverPayload;
    if (loadTruckDriver !== "Custom") {
      manifestDriverPayload = {
        pickupDriverId: selectedTruck[0]?.vehicleNo,
      };
      if (!state?.selectedDriver) {
        message.error("Please select driver");
        return;
      }
    } else {
      manifestDriverPayload = {
        pickupDriverName: payload.driverName,
        vehicleNumber: payload.vehicleNumber,
        contactNumber: payload.contactNumber || null,
      };
    }

    setLoading(true);
    try {
      const response = await API.Api(
        `${LOAD_TO_VEHICLE}${manifestedId?.id}/driver`
      ).putCustomIdHeader(manifestDriverPayload);

      if (response?.status) {
        setLoading(false);
        setState((prev) => ({
          ...prev,
          // loading: false,
          filteredTruck: selectedTruck,
        }));

        if (checkEwayBills) {
          navigate(`/cp-eway-bill/${manifestedId?.id}`, {
            state: {
              manifestId: manifestedId?.id,
              driverName: payload?.driverName || state?.selectedDriver?.name,
              vehicleNo: payload?.vehicleNumber || payload?.pickupDriverId,
            },
          });
          message.success("Loaded to vehicle");
        } else {
          handleStatus();
        }
      } else {
        setLoading(false);
        message.error(response?.response?.data?.message || "Network error");
      }
    } catch (error) {
      message.error("Failed to load vehicle");
      setLoading(false);
    }
  };

  const [hubName, setHubName] = useState("");
  const getManifestedList = async () => {
    setLoading(true);
    try {
      const response = await API.Api(
        `${GET_MANIFESTED_SHIPMENTS}/${manifestedId?.id}`
      ).getWithAllHeaders();

      if (response?.status) {
        setLoading(false);
        const manifestData = response?.response?.data;
        setHubName(manifestData?.toHub);

        let arr =
          response?.response?.data?.shipmentScanDtos?.map(
            (val) => val?.packetsdto
          ) || [];

        let arr2 =
          response?.response?.data?.shipmentScanDtos.map(
            (val) => val?.shipmentDetails
          ) || [];

        let arr3 = [...arr, ...arr2];
        let filtered = arr3?.filter(function (el) {
          return el != null;
        });
        setState((prev) => ({
          ...prev,
          manifestListArr: filtered || [],
          manifestData: {
            totalweight: manifestData?.totalweight || 0,
            totalVolWeight: manifestData?.totalVolWeight || 0,
          },
        }));
      } else {
        message.error(
          response?.response?.data?.message ||
            "Failed to fetch manifested shipments"
        );

        setLoading(false);
      }
    } catch (error) {
      message.error("Failed to fetch manifested shipments");

      setLoading(false);
    }
  };

  const getVehicleListData = async () => {
    setLoading(true);
    try {
      const response = await API.Api(
        GET_VEHICLES_TO_LOAD
      ).getWithPremiseHeader();

      if (response?.status) {
        setState((prev) => ({
          ...prev,
          vehicleResultData: response?.response?.data || [],
        }));
      } else {
        message.error(
          response?.response?.data?.message || "Failed to fetch vehicle list"
        );
        setLoading(false);
      }
    } catch (error) {
      message.error("Failed to fetch vehicle list");
      setLoading(false);
    }
  };

  // Effects
  useEffect(() => {
    const initializeData = async () => {
      await Promise.all([getManifestedList(), getVehicleListData()]);
    };

    initializeData();
  }, []);

  useEffect(() => {
    // if (!radioValue) return;

    const filterTruckData = filterByweightTruck?.filter(
      (_, index) => index === radioValue
    );
    getDriverList(filterTruckData);
    setState((prev) => ({ ...prev, selectedTruck: filterTruckData }));
  }, [radioValue]);

  // Render helper functions
  const renderShipmentCards = () => {
    if (!filterManifestShips?.length) {
      return (
        <div className="empty-state">
          <Empty description="No shipments to load" />
        </div>
      );
    }

    return manifestListArr?.map((el, idx) => {
      if (
        Object.keys(el)?.includes("packetBarcode") &&
        el?.status === "MANIFESTED"
      ) {
        return <Bigcard item={el} key={idx} />;
      }
      if (
        Object.keys(el)?.includes("awbNumber") &&
        el?.bookingStatus?.toUpperCase() === "MANIFESTED"
      ) {
        return <Minicard item={el} key={idx} color="greens" />;
      }
      return null;
    });
  };

  const renderTruckSection = () => {
    if (loadTruckDriver === "Custom") {
      return (
        <CustomTruckForm
          form={customForm}
          loaded={loaded}
          filterManifestShips={filterManifestShips}
          onSubmit={customLoadToVehicleSubmit}
        />
      );
    }

    // form.setFieldValue("contactNumber", "dsdsdss");
    return (
      <TruckList
        form={form}
        trucks={filterByweightTruck}
        radioValue={radioValue}
        hubName={hubName}
        editBtnStatus={editBtnStatus}
        onRadioChange={onRadioChange}
        state={state}
        setState={setState}
        setLoading={setLoading}
        customLoadToVehicleSubmit={customLoadToVehicleSubmit}
        // driverSelectHandle={driverSelectHandle}
        driverNameList={driverNameList}
      />
    );
  };

  return (
    <div>
      <Spin
        spinning={state.loading || loading}
        indicator={
          <img
            src={Smcs_Loader}
            style={{ height: "100px", width: "100px", marginLeft: "-44px" }}
          />
        }
      >
        <Row className="truck-container">
          <Col className="left">
            <Header
              shipmentCount={filterManifestShips?.length}
              totalWeight={
                filterManifestShips?.length == 0 ? 0 : manifestData?.totalweight
              }
              totalVolWeight={
                filterManifestShips?.length == 0
                  ? 0
                  : manifestData?.totalVolWeight
              }
            />
            <Row className="outer-container">
              <Row className="main-table" gutter={32}>
                {renderShipmentCards()}
              </Row>
            </Row>
          </Col>

          <Col className="right">
            <TruckHeader
              loadTruckDriver={loadTruckDriver}
              onDriverLoadChange={onDriverLoadChange}
            />
            <Row className="truck-row">{renderTruckSection()}</Row>
            <Footer
              filterByweightTruck={filterByweightTruck}
              filterManifestShips={filterManifestShips}
              setState={setState}
              loadToVehicle={loadToVehicle}
              state={state}
              loadTruckDriver={loadTruckDriver}
              customForm={customForm}
              checkEwayBills={checkEwayBills}
              // onUpdateEway={handleUpdateEway}
              onLoadVehicle={customLoadToVehicleSubmit}
            />
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default ManifestComponent;
